import React from "react";
import Rect1436 from "../../Assets/img/Rectangle 1436.svg";
import Rect1437 from "../../Assets/img/Rectangle 1437.svg";
import Rect1438 from "../../Assets/img/Rectangle 1438.svg";
import Checkmark from "../../Assets/img/checkmark 1.svg";

const ImageContentSection = () => {
  return (
    <section className="image-content mt-lg-5 ">
      <div className="container">
        <div className="row g-4 p-0">
          {/* Image Column */}
          <div className="col-lg-6 d-flex justify-content-center gap-2">
            {/* Left Image */}
            <div className="ellipse-wrapper">
              <div className="ellipse-card">
                <img src={Rect1436} alt="Person 1" />
              </div>
              <div className="ellipse-shadow"></div>
            </div>

            {/* Middle Image (Raised) */}
            <div className="ellipse-wrapper middale-card">
              <div className="ellipse-card">
                <img src={Rect1437} alt="Group" />
              </div>
              <div className="ellipse-shadow"></div>
            </div>

            {/* Right Image */}
            <div className="ellipse-wrapper">
              <div className="ellipse-card">
                <img src={Rect1438} alt="Woman" />
              </div>
              <div className="ellipse-shadow"></div>
            </div>
          </div>

          {/* Text Column */}
          <div className="col-lg-6 text-start p-0">
            <h3 className="fw-bold mb-3">
              Delivering Talent That Drives <br /> Business Success
            </h3>

            <p className="text-justify">
              At the core of our recruitment philosophy is a bold vision: to redefine
              how talent meets opportunity in a fast-evolving world. As a trusted and
              forward-thinking recruitment partner, we specialize in bridging the gap
              between skilled professionals and ambitious organizations across industries
              and global markets.
            </p>

            <p className="text-justify">
              Whether you're a company seeking to build agile, high-performing teams
              or a professional looking to elevate your career, we offer intelligent,
              data-driven, and fully customized recruitment solutions. Our approach blends
              human insight with cutting-edge technology to ensure every hire is a
              strategic fit — not just for today, but for the future of your business
              or career.
            </p>

            <ul className="list-unstyled mt-4">
              <li className="mb-3 d-flex align-items-start gap-2">
                <img src={Checkmark} alt="Check" style={{ width: "20px" }} />
                <span>Smart, scalable hiring solutions for today’s businesses.</span>
              </li>
              <li className="d-flex align-items-start gap-2">
                <img src={Checkmark} alt="Check" style={{ width: "20px" }} />
                <span>Global network connecting top talent with leading companies.</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ImageContentSection;
